import ApiService from '@/services/api.service.js';

export const EvaluationService = {

  submitEvaluation: function (data) {
    return ApiService.post('/evaluation/application', data);
  },

  changeStatus: function (data)
  {
    return ApiService.post('/evaluation/change-status', data);
  },

  conceptEvaluationStatus: function (data)
  {
    return ApiService.post('/evaluation/cn-evaluation-status', data);
  },

  exportEvaluation: function (data) {
    return ApiService.post('/evaluation/export', data);
  },

  exportConceptEvaluation: function (data) {
    return ApiService.post('/evaluation/cn-export', data);
  },

  getApplicationEvaluation: function (data) {
    return ApiService.post('/evaluation/get-application', data);
  },

  getEvaluationTypes: function (grantId) {
    return ApiService.get('/evaluation-types/' + grantId);
  },

  getEvaluationTypeNickname: function (nickname, applicationId) {
    return ApiService.get('/evaluation-type/' + nickname + '/' + applicationId);
  },

  validateEvaluation: function (id) {
    return ApiService.get('/evaluation-validate/' + id);
  },

  deleteEvaluation: function (data)
  {
    return ApiService.post('/evaluation/delete-evaluation', data);
  }
}

export default EvaluationService
